import * as React from "react";
import * as ReactDom from "react-dom";

import { usePortal, UsePortalProps } from "./use-portal";

interface PortalProps extends UsePortalProps {}

export const Portal: React.FunctionComponent<PortalProps> = (props) => {
  const target = usePortal(props);
  return ReactDom.createPortal(props.children || [], target);
};
